module.exports = __webpack_public_path__ + "img/6.2c95f569.jpg";